// src/utils/fetchCurrentUser.js
import { apiGet } from '@/api/apiClient';
import { fetchClubUserSession } from '@/api/clubSession.js';

function getPathname() {
  if (typeof window === 'undefined') return '';
  try {
    return window.location?.pathname || '';
  } catch {
    return '';
  }
}

export function extractClubCodeFromPath(path) {
  if (!path || typeof path !== 'string') return null;
  const match = path.match(/^\/(\d{6})(?:\b|\/)/);
  return match ? match[1] : null;
}

export async function fetchCurrentUser() {
  const pathname = getPathname();
  const clubCode = extractClubCodeFromPath(pathname);

  if (clubCode) {
    const session = await fetchClubUserSession(clubCode);
    const clubUser = session?.club_user || {};
    const normalizedUser = {
      ...clubUser,
      id: clubUser.id ?? clubUser.staff_id ?? clubUser.user_id ?? null,
      user_id: clubUser.user_id ?? clubUser.staff_id ?? clubUser.id ?? null,
      staff_id: clubUser.staff_id ?? clubUser.id ?? null,
      club_code: clubUser.club_code ?? clubCode,
    };
    return {
      ...normalizedUser,
      club_user: normalizedUser,
      modules: session?.modules || [],
      club_modules: session?.modules || [],
    };
  }

  const endpoints = ['/api/admin/me', '/api/me'];
  let lastError = null;

  for (const endpoint of endpoints) {
    const res = await apiGet(endpoint);
    if (res?.ok) {
      return res?.data ?? res;
    }
    lastError = res;
  }

  const error = new Error(lastError?.error || 'not allowed');
  error.status = lastError?.status;
  error.response = lastError;
  throw error;
}

export default fetchCurrentUser;
